import {MARKET} from '../config';

export const getCurrencyRate = () => {
    switch (MARKET) {
        case 'en':
            return 2;

        case 'cz':
            return 25;

        case 'pl':
            return 4.25;

        case 'hu':
            return 393;

        case 'ro':
            return 5;
    }

    return 1;
};
